module.exports = __webpack_public_path__ + "img/dcPvFlow.1a54026a.gif";